import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Vehicle road tax notification context enum
 * @description Notification contexts specific to vehicle road tax subjects
 */
export enum VehicleRoadTaxNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Vehicle road tax-specific contexts
	PENDING = 'pending',
	ACTIVE = 'active',
	EXPIRED = 'expired',
}
